// extracted by mini-css-extract-plugin
export var card = "ProfileCard-module--card--72a29";
export var content = "ProfileCard-module--content--d353f";
export var image = "ProfileCard-module--image--515c7";
export var name = "ProfileCard-module--name--25bdf";
export var profile = "ProfileCard-module--profile--97876";